<template>
  <v-card fill-height fluid>
    <v-tabs
      v-model="tab"
      background-color="primary"
      dark
    >
      <v-tab
        v-for="item in items"
        :key="item.tab"
        v-if="$store.state.auth.checkAccess({key: item.access, value: true}) || !item.access"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items touchless v-model="tab">
      <v-tab-item
        v-for="item in items"
        :key="item.tab"
        v-if="$store.state.auth.checkAccess({key: item.access, value: true}) || !item.access"
      >
        <component :is="item.dist" :title="item.tab" :url="item.url" />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<style>
</style>

<script>

  export default {

    components: {
      Vip: () => import('@/components/vip/Vip.vue'),
      PotentialVip: () => import('@/components/vip/Potential-Vip.vue'),
    },

    data: () => ({
      tab: null,
      items: [
        { tab: 'Vip', dist: 'vip' },
        { tab: 'Potential Vip', dist: 'potential-vip' },
      ]
    }),

    mounted () {
    },

    methods: {},
  }
</script>
